import http from './http'
import { stringify } from 'qs'
import { HALL_URLTYPE, HALL_APPID, WECHAT_URL, WECHAT_SYS, service_url, extraWindows_url, accessToken } from './config'
import {mockData} from './mockData'

// 获取办事指南基本信息
export const getGuideBasicInfo = (params) => {
    params.access_token = accessToken;
    var instance = http.create({
        baseURL: '',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
        params: params
    });
    return instance.post('/fwapi/c/api.transfer/getAllItemInfoByItemID')
}
// 获取办事指南材料信息
export const getGuideMaterials = () => {
    return new Promise(r => {
        return r(
            mockData.getGuideMaterials
        )
    })
}

//获取优先办事事项列表
export const getPriorProjectList = (params) => {
    http.defaults.baseURL = service_url;
    params.access_token = accessToken;
    params.appId = HALL_APPID;
    return http.post('api/client/getPriorProjectList', stringify(params))
}

//获取事项可办理的窗口信息及等待人数
export const getWindowWaitNumByProjectId = (params) => {
    http.defaults.baseURL = extraWindows_url;
    params.access_token = accessToken;
    params.appId = HALL_APPID;
    return http.post('api/extra/windows/getWindowWaitNumByProjectId', stringify(params))
}

//获取所有大厅信息列表（简略信息）
export const getAllHallBriefList = (params) => {
    http.defaults.baseURL = service_url;
    params.access_token = accessToken;
    params.appId = HALL_APPID;
    return http.post('api/hallExtend/getAllHallBriefList', stringify(params))
}

//获取按大厅类型统计数据
export const getHallAllCount = (params) => {
    http.defaults.baseURL = service_url;
    params.access_token = accessToken;
    params.appId = HALL_APPID;
    return http.post('api/hallExtend/getHallAllCount', stringify(params))
}

//获取大厅信息分页列表
export const getHallList = (params) => {
    params.access_token = accessToken;
    params.appId = HALL_APPID;
    http.defaults.baseURL = '';
    return http.post('/fwapi/c/api.transfer/getHallList_Map', stringify(params))
}
//获取大厅详细信息
export const getHallInfo = (params) => {
    http.defaults.baseURL = service_url;
    params.appId = HALL_APPID;
    params.access_token = accessToken;
    return http.post('/fwapi/c/api.transfer/getHallInfo_Map', stringify(params))
}
//获取评价满意度标签列表
export const getAppraiseLabels = (params) => {
    http.defaults.baseURL = service_url;
    params.appId = HALL_APPID;
    params.access_token = accessToken;
    return http.post('/fwapi/c/api.transfer/getAppraiseLabels', stringify(params))
}

//提交对大厅的评价信息
export const submitAppraise = (params) => {
    http.defaults.baseURL = service_url;
    params.appId = HALL_APPID;
    params.access_token = accessToken;
    return http.post('/fwapi/c/api.transfer/submitAppraise_Map', stringify(params))
}

//提交对大厅的点赞信息
export const submitApproval = (params) => {
    http.defaults.baseURL = service_url;
    params.appId = HALL_APPID;
    params.access_token = accessToken;
    return http.post('api/hallExtend/submitApproval', stringify(params))
}

//附件下载(图片预览)
export const fileDownload = (params) => {
    http.defaults.baseURL = service_url;
    return http.get('/fwapi/c/api.transfer/file/' + params.fileName)
}

//获取预约事项列表
export const getProjectList = (params) => {
    http.defaults.baseURL = service_url;
    params.appId = HALL_APPID;
    params.access_token = accessToken;
    return http.post('/fwapi/c/api.transfer/getProjectList_Map', stringify(params))
}

// 获取市政服务站点列表
export const getSiteList = (params) => {
    // let result = {
    //     "state": 1,//结果状态
    //     "message": "获取成功",//结果描述
    //     "info": [
    //         {
    //             "siteId": "702471072380878848",//地点ID
    //             "siteCode": "GNYYWD1",//地点编码
    //             "siteName": "供暖营业网点1",//地点名称
    //             "siteEnglishName": "供暖营业网点1",//地点英文名称
    //             "regionCode": "440100",//区划编码
    //             "regionName": "广州市",//区划名称
    //             "siteType": "1",//市政服务类型
    //             "siteTypeName": "供暖营业网点",//市政服务类型名称
    //             "longitude": "113.326911",//经度
    //             "latitude": "23.12388",//纬度
    //             "distance": 900,//距离
    //             "image": "3414aa77-161f-11ec-b7bd-005056ab267e.jpeg",//缩略图
    //             "labelNames": [
    //                 "无线上网",
    //                 "茶水间",
    //                 "免费停车",
    //                 "自助服务",
    //                 "无线充电",
    //                 "休息区",
    //                 "24小时终端"
    //             ]//标签列表
    //         },
    //         {
    //             "siteId": "702471072380878847",//地点ID
    //             "siteCode": "GNYYWD1",//地点编码
    //             "siteName": "供暖营业网点2",//地点名称
    //             "siteEnglishName": "供暖营业网点2",//地点英文名称
    //             "regionCode": "440100",//区划编码
    //             "regionName": "广州市",//区划名称
    //             "siteType": "1",//市政服务类型
    //             "siteTypeName": "供暖营业网点",//市政服务类型名称
    //             "longitude": "113.326961",//经度
    //             "latitude": "23.12348",//纬度
    //             "distance": 900,//距离
    //             "image": "3414aa77-161f-11ec-b7bd-005056ab267e.jpeg",//缩略图
    //             "labelNames": [
    //                 "无线上网",
    //                 "茶水间",
    //                 "免费停车",
    //                 "自助服务",
    //             ]//标签列表
    //         }
    // ,
    //     ]
    // }

    // return new Promise((r, j) => {
    //     return r(result)
    // })
    http.defaults.baseURL = service_url;
    params.appId = HALL_APPID;
    params.access_token = accessToken;
    return http.post('api/site/getSiteList', stringify(params))
}

// 获取市政服务站点信息
export const getSiteInfo = (params) => {
    http.defaults.baseURL = service_url;
    params.appId = HALL_APPID;
    params.access_token = accessToken;
    return http.post('api/site/getSiteInfo', stringify(params))
}

// 获取事项列表
export const getProjectNameCount = (params) => {
    params.access_token = accessToken;
    params.isStandard = '1';
    var instance = http.create({
        baseURL: '',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
        params: params
    });
    return instance.post('/fwapi/c/api.transfer/getItemListByPage')
}

// 获取事项详情
export const getItemInfoByItemCode = (params) => {
    params.access_token = accessToken;
    var instance = http.create({
        baseURL: '',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
        params: params
    });
    return instance.get('/fwapi/c/api.transfer/getItemInfoByItemCode')
}
// 获取浪潮事项系统事项详情
export const getPriorProjectListByItemCode = (params) => {
    params.access_token = accessToken;
    params.appId = HALL_APPID;
    var instance = http.create({
        baseURL: '',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
        params: params
    });
    return instance.post('/fwapi/c/api.transfer/getPriorProjectListByItemCode')
}
// 获取浪潮事项系统事项详情
export const getPriorProjectInfo = (params) => {
    params.access_token = accessToken;
    params.appId = HALL_APPID;
    return http.post('/fwapi/c/api.transfer/getPriorProjectInfo', stringify(params))
    // var instance = http.create({
    //     baseURL: '',
    //     headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
    //     params: params
    // });
    // return instance.post('/fwapi/c/api.transfer/getPriorProjectInfo')
}

// 获取浪潮事项系统大厅详情
export const yygetHallInfo = (params) => {
    params.access_token = accessToken;
    params.appId = HALL_APPID;
    return http.post('/fwapi/c/api.transfer/yygetHallInfo', stringify(params))
}
//  获取部门列表
export const getDeptList = (params) => {
    params.access_token = accessToken;
    // http.defaults.baseURL = '/api';
    params.appId = HALL_APPID;
    return http.post('/fwapi/c/api.transfer/getItemDeptList', stringify(params))
}
//  获取部门列表
export const getItemList = (params) => {
    params.access_token = accessToken;
    params.appId = HALL_APPID;
    return http.post('/fwapi/c/api.transfer/getyyItemList', stringify(params))
    // return http.post('/fwapi/c/api.transfer/getyyItemList', stringify(params))
}

export const getProjectList_Map = (params) => {
    params.access_token = accessToken;
    // http.defaults.baseURL = '/api';
    params.appId = HALL_APPID;
    return http.post('/fwapi/c/api.transfer/getHallListByItem', stringify(params))
}
// export const getWindowListInfo = (params) => {
//     if(HALL_URLTYPE == "2") {
//         http.defaults.baseURL = '/';
//         params.appId = HALL_APPID;
//         return http.post('extraWindows/api/extra/windows/getWindowWaitNumByHallId', stringify(params))
//     }
// }
export const getProjectList1 = (params) => {
    http.defaults.baseURL = '';
    // var form = new FormData()
    // for (var key in params) {
    //     form[key] = params[key]
    // }
    // var instance = http.create({
    //     baseURL: '/api',
    //     headers: { 'Content-Type': 'multipart/form-data','appId': HALL_APPID},
    //     data: form,
    //     params:params
    // });
    params.appId = HALL_APPID;
    params.access_token = accessToken;
    return http.post('/fwapi/c/api.transfer/getProjectList_Map', stringify(params))
}
export default {
    getPriorProjectList,
    getWindowWaitNumByProjectId,
    getAllHallBriefList,
    getHallAllCount,
    getHallList,
    getHallInfo,
    getAppraiseLabels,
    submitAppraise,
    submitApproval,
    fileDownload,
    getProjectList,
    getSiteList,
    getSiteInfo,
    getProjectNameCount,
}
